<template>
    <div class="pad:-mx-5 pad:-my-1 md:m-0">
        <h3 class="text-center pt-5 pad:pt-8 mt-0 mb-5 pad:mb-10">
            沒有瀏覽權限，如要操作線上交易請重新登入
        </h3>
    </div>
    <div class="sm:px-5 pad:p-0">
        <TermsHome />
    </div>
</template>

<script>
import TermsHome from '@/components/termContent/TermsHome.vue';

export default {
    name: 'Home',
    components: {
        TermsHome,
    },
};
</script>

<style scoped>
.home-collapse-title-btn {
    @apply bg-white text-base xs:text-lg pad:text-xl h-[3.75rem] pad:h-[8.25rem] w-full pad:w-60 lg:w-[15.9375rem] no-animation rounded-md shadow-3 border-0;
}

.home-collapse-content {
    @apply px-2.5 pt-4 pb-2.5 grid grid-cols-2 gap-2.5 pad:p-0 pad:grid-cols-none pad:gap-0 pad:w-[45.9375rem] lg:w-[51.5625rem] pad:flex pad:absolute pad:left-1/2 pad:-translate-x-1/2;
}

.home-content-btn {
    @apply xs:text-lg rounded-md bg-white text-black border border-gray-200 shadow-4 h-auto lg:hover:bg-primary lg:hover:border-gray-200 lg:hover:text-white p-0;
}

.modal-button {
    @apply fixed bottom-2.5 left-0 pad:left-[3.1875rem] bg-error w-[2.75rem] h-[2.75rem] flex justify-center items-center rounded-r pad:rounded cursor-pointer;
}

.btnArrow::after {
    @apply content-[''] block w-0 h-0 border-solid absolute left-1/2 bottom-0.5 translate-y-full -translate-x-1/2;
    border-width: 20px 16px 0 16px;
    border-color: #489abd transparent transparent transparent;
    filter: drop-shadow(0 2px 5px #0000001a);
}
</style>
